import { createSelector } from 'reselect';
import expandModule from './expandModule';
import modulesListSelector from './modulesList';

export default createSelector(modulesListSelector, (modules) =>
    modules.map((module) => expandModule(module)),
);
